
import { Component, Vue, Prop } from 'vue-property-decorator'
import { CustomButton, Card } from 'ui-library'
import { navigate } from '@/utils/NavigationUtils'
import TeaserAccount from '@/componentsTenant/images/TeaserAccount.vue'

// Tile with component top and image bottom
@Component({ components: { Card, CustomButton, TeaserAccount } })
export default class TeaserAccountTile extends Vue {
  @Prop({ default: true }) private showImage!: boolean
  @Prop({ default: true }) private showAsBox!: boolean
  @Prop({ default: '' }) private title!: string
  @Prop({ default: true }) private footerDivider!: boolean
  @Prop({}) private text!: string
  @Prop({ default: '' }) private primaryButtonText!: string
  @Prop({ default: '' }) private primaryButtonLink!: string
  @Prop({ default: 'cta' }) private primaryButtonColor!: string
  @Prop({}) private primaryTrackingId!: string
  @Prop({}) private secondaryButtonText!: string
  @Prop({}) private secondaryButtonLink!: string
  @Prop({ default: 'cta-link' }) private secondaryButtonColor!: string
  @Prop({}) private secondaryTrackingId!: string

  private assetsBaseUrl: string = window.ENV_CONFIG.ASSETS_BASE_URL.CUSTOMER_PORTAL || ''

  public onClick(link: string): void {
    navigate(link)
  }
}
